import {getPlatform} from './getPlatform';
import {isMobileDevice} from './isMobileDevice';

import getTabs from './getTabs';
import rowSpcBtw from './rowSpcBtw';
import rowCenter from './rowCenter';
import flexCenter from './flexCenter';
import columnCenter from './columnCenter';
import numberOfLines from './numberOfLines';
import rowCenterWrap from './rowCenterWrap';
import rowCenterSpcBtw from './rowCenterSpcBtw';
import rowWrapSpcBtween from './rowWrapSpcBtween';
import rowCenterFlexEnd from './rowCenterFlexEnd';
import rowCenterSpcAround from './rowCenterSpcAround';
import columnCenterSpcBtween from './columnCenterSpcBtween';

export const utils = {
  getTabs,
  rowCenter,
  flexCenter,

  rowSpcBtw,
  getPlatform,
  columnCenter,
  numberOfLines,
  rowCenterWrap,
  isMobileDevice,
  rowWrapSpcBtween,
  rowCenterFlexEnd,
  rowCenterSpcBtw,
  rowCenterSpcAround,
  columnCenterSpcBtween,
};
